import { marqueeItems } from "@/data/skills";

export function TechStack() {
  return (
    <section className="border-y border-line py-12 md:py-16" data-testid="techstack-section">
      <p className="eyebrow container-x mb-10">07 — STACK</p>
      <div className="marquee" data-testid="tech-marquee">
        <div className="marquee-track">
          {[0, 1].map((copy) => (
            <div className="flex" key={copy} aria-hidden={copy === 1}>
              {marqueeItems.map((item) => (
                <span
                  key={`${copy}-${item}`}
                  className="marquee-item font-display text-2xl font-medium tracking-tight text-muted transition-colors hover:text-foreground md:text-4xl"
                >
                  {item}
                  <span className="ml-8" style={{ color: "var(--accent)" }}>
                    ·
                  </span>
                </span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
